<template>
    <div class="mainDiv">
    <el-form  ref="queryCondition" :model="queryCondition">
      <el-row >
        <el-col :span="10">
          角色名称
          <el-input size="mini" v-model="queryCondition.roleName" clearable placeholder="请输入内容" class="dialogDataWidth" style="width: 60%;"></el-input>
        </el-col>
        <el-col :span="6">
          角色类型
          <el-select size="mini" v-model="queryCondition.roleType" clearable placeholder="请选择" class="dialogDataWidth"  style="width: 60%;">
              <el-option v-for="item in type_option" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
        </el-col>
        <el-col :span="6" >
          <el-button type="primary" size="mini" @click='query(1)' icon="el-icon-search">查询</el-button>
          <el-button type="primary" plain size="mini" @click="reset" icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-top: 10px;">
        <el-col :span="24">
          <el-button type="primary" size="mini" @click='roleAdd' icon="el-icon-plus">新增</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-table class="el-table" stripe size="mini" :data="pagedata.content" align="center" style="margin-top: 10px;" header-row-class-name="tableHeader">
      <el-table-column align='center' prop="id" type="index" label="序号"  label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="roleName" label="角色名称" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="roleDesc" label="角色描述" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="roleType" label="角色类型" :formatter="formatType" label-class-name="greenLabel"></el-table-column>
      <el-table-column fixed="right" align="left" label="操作" width="260">
        <template slot-scope="scope">
          <el-tooltip content="编辑"  placement="top" effect="light">
            <el-button @click="roleEdit(scope.row)" icon="el-icon-edit" size="small"></el-button>
          </el-tooltip>
          <el-tooltip content="授权"  placement="top" effect="light">
            <el-button @click="roleAuth(scope.row)" icon="el-icon-setting" size="small"></el-button>
          </el-tooltip>
          <el-tooltip content="选人"  placement="top" effect="light">
            <el-button @click="selectUser(scope.row)" icon="el-icon-user" size="small"></el-button>
          </el-tooltip>
          <el-tooltip content="删除" v-if="scope.row.id != 1" placement="top" effect="light">
            <el-button type="danger" plain @click="roleDelete(scope.row)" icon="el-icon-delete" size="small"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

      <el-pagination
        :page-size="pagedata.size"
        layout="total, prev, pager, next, jumper"
        :total="pagedata.totalElements"
        :current-page.sync="pagedata.number"
        @current-change="query" class="mb">
      </el-pagination>

    <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="520px" :fullscreen="false" @close="query" :close-on-click-modal="false">
      <role :roleRow="roleRow"  @closeRole="closeRole"></role>
    </el-dialog>

    <el-dialog :title="authRoleName" v-if="authVisible" :visible.sync="authVisible" width="30%" :fullscreen="false" @close="query" :close-on-click-modal="false">
      <roleAuth :roleRow="roleRow"  @closeRole="closeRole"></roleAuth>
    </el-dialog>

    <el-dialog title="人员选择" v-if="userVisible" :visible.sync="userVisible" width="40%" :fullscreen="false" @close="query" :close-on-click-modal="false">
      <userSelect :userSelectData="userSelectedIdList" @userSelect="userSelectMethod"></userSelect>
    </el-dialog>

    </div>
</template>
<script>
  import role from '@/components/role/role'
  import roleAuth from '@/components/role/roleAuth'
  import userSelect from '@/components/common/userSelect'

  export default {
    name: 'roleList',
    components: {
      role,
      roleAuth,
      userSelect
    },
    mounted: function () {
      this.type_option = this.CommonUtil.getCodeList('role_type');
      this.query();
    },
    data() {
      return {
        msg: 'this is role',
        roleRow: {
          id: 0,
          roleName: '',
          roleDesc: '',
          roleType:''
        },
        userSelectedIdList: [],
        userVisible: false,
        authRoleName: '',
        addVisible: false,
        authVisible:false,
        queryCondition: {
          roleName: '',
          roleType: ''
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          size: 10,
          number: 1,
        },
        type_option: [],
        dialogTitle:''
      }
    },
    methods: {
      //状态改成汉字
      formatType(row, column) {
        if (row.roleType == '1') {
          return '功能性角色';
        }
        if (row.roleType == '2') {
          return '岗位性角色';
        }
      },
      closeRole(){
        this.query();
        this.addVisible = false;
        this.authVisible = false;
      },
      // 查询按钮
      query: function (currentPage) {
        if(!isNaN(currentPage) && currentPage > 0){
          this.pagedata.number = currentPage;
        }
        var url = '/role/rolePage';
        url += '?roleName=' + this.queryCondition.roleName;
        url += '&roleType=' + this.queryCondition.roleType;
        url += '&pageNumber=' + this.pagedata.number  + '&pageSize=' + this.pagedata.size;
        this.$axios.get(url).then(response => {
          if (response.data !== null && response.data !== '' && response.data !== undefined) {
            this.pagedata = response.data;
          }
        })
      },
      reset: function () {
        this.queryCondition.roleName = '';
        this.queryCondition.roleType = '';
        this.$refs.queryCondition.resetFields();
        this.query(1);
      },
      roleEdit: function (row) {
        this.roleRow = row;
        this.roleRow.roleType= this.roleRow.roleType+ '';
        this.dialogTitle = '修改角色';
        this.addVisible = true;
      },
      closeEdit: function () {
        this.addVisible = false;
      },
      roleAdd: function () {
        this.roleRow = {};
        this.dialogTitle = '新增角色';
        this.addVisible = true;
      },
      roleAuth:function(row){
        this.roleRow = row;
        this.authRoleName = '请给 ' + row.roleName + ' 授权';
        this.authVisible = true;
      },
      roleDelete: function (row) {
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/role/roleDelete?id=' + row.id).then(response => {
            if(response.code == '0000'){
              this.query();
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
              this.$message({
                type: 'warning',
                message: response.message
              });
            }

          });
        })
      },
      /**
       * 给角色选人
       */
      selectUser(row){
        this.roleRow = row;
        this.$axios.get('/user/getUserByRole/' + row.id).then(response => {
          this.userSelectedIdList = response.data;
          this.userVisible = true;
        })
      },
      /**
       * 选定人员后保存
       */
      userSelectMethod(data) {
        var userIds = [];
        for (var i = 0; i < data.length; i++) {
          userIds.push(data[i].id);
        }
        this.$axios.post('/user/saveUserByRole', {
          roleId: this.roleRow.id,
          userIds: userIds
        }).then(response => {
          this.userVisible = false;
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
        })
      },
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/role/roleList.vue